var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirecttvAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 34,
    viewBox: "0 0 25 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8817 3.4589C18.7278 1.2013 15.5803 0.263184 11.6228 0.263184H0V25.3687C2.10568 24.5401 4.2814 23.7335 6.52716 22.9488V6.08474H11.5177C13.6716 6.08474 15.2957 6.83874 16.3332 8.15385C17.5896 9.74513 17.7122 11.0909 17.7122 19.4068C19.8441 18.7975 24.2569 17.6446 24.2569 17.6446C24.2569 9.58294 24.2569 7.00094 20.8817 3.4589Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.065 33.7193C15.5321 33.7193 18.6797 32.7286 20.886 30.5148C22.8429 28.5597 23.6746 26.2933 24.0249 23.8604C16.0706 26.8281 8.93929 30.1597 2.76672 33.7193H12.065Z",
    fill: "#337ACE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirecttvAvatar);
export default __webpack_public_path__ + "static/media/directtv_avatar.f3ea29530b0a945a7f4ed3c49e0a2b0b.svg";
export { ForwardRef as ReactComponent };